export default __webpack_public_path__ + "static/media/detail_mobile_9_4.2389865b.jpg";